// 11 §13.4 — the desktop app's updates: checked on boot and every 6 h, downloaded quietly, then a banner
// offers the restart. main does the work (electron-updater, off in Steam builds and unpackaged runs,
// where `check()` resolves null); the browser has no bridge and renders nothing.
import { useEffect, useState } from 'react';
import { Banner, Button } from '../components';
import { desktopBridge } from '../../core/desktop';

/** The first check waits for the first screen to settle; then every six hours. */
const FIRST_CHECK_MS = 15_000;
const EVERY_MS = 6 * 60 * 60_000;

export function UpdateBanner() {
  const [ready, setReady] = useState<string | null>(null);
  const [later, setLater] = useState(false);
  useEffect(() => {
    const d = desktopBridge();
    if (!d) return undefined;
    let busy = false;
    const check = async () => {
      if (busy) return;
      busy = true;
      try {
        const found = await d.update.check();
        if (!found) return;
        await d.update.download();
        setReady(found.version);
        setLater(false);
      } catch (err) {
        console.warn('[update]', err);   // offline, rate-limited: the next round tries again
      } finally { busy = false; }
    };
    const first = setTimeout(() => void check(), FIRST_CHECK_MS);
    const every = setInterval(() => void check(), EVERY_MS);
    return () => { clearTimeout(first); clearInterval(every); };
  }, []);
  if (!ready || later) return null;
  return (
    <Banner tone="info" data-testid="update-banner">
      <span>Fellowkeep {ready} is ready. It installs when you quit, or now.</span>
      <Button small primary onClick={() => desktopBridge()?.update.quitAndInstall()}>Restart now</Button>
      <Button small variant="ghost" onClick={() => setLater(true)}>Later</Button>
    </Banner>
  );
}
